/**
 * Util for Checking if route is among provided list of routes
 * @param routerPath the router path
 * @param routes the list of routes
 * @returns true if provided route is among list of routes
 */
export const isRouterPathMatchingOneOfRoutes = (routerPath: string, routes: string[]): boolean => {
  let isPreviousRouteAmongRoutes = false;

  if (!routerPath || !routes) return;

  routes.forEach((route) => {
    if (routerPath.match(new RegExp(route))) {
      isPreviousRouteAmongRoutes = true;
    }
  });

  return isPreviousRouteAmongRoutes;
};

const DUMMY_BASE_ALLOWING_RELATIVE_URL_PARSING = 'http://dummy-base';

/**
 * Util for rejecting a login callback url that would send the user back to the login page
 * @param callbackUrl the callback url requested for after sign in
 * @param loginPagePath the path of the login page
 * @returns the callback url, or null if it is missing, unparseable or targets the login page
 */
export const sanitizeLoginCallbackUrl = (callbackUrl: string, loginPagePath: string): string => {
  if (!callbackUrl) return null;

  try {
    const parsedCallbackUrl = new URL(callbackUrl, DUMMY_BASE_ALLOWING_RELATIVE_URL_PARSING);

    return parsedCallbackUrl.pathname === loginPagePath ? null : callbackUrl;
  } catch {
    return null;
  }
};

/**
 * Util for Checking if route is matching provided route
 * @param routerPath the router path
 * @param route the route
 * @returns true if provided route is matching router route
 */
export const isRouterPathMatchingRoute = (routerPath: string, routeRegexp: string): boolean => {
  if (!routerPath || !routeRegexp) return false;

  if (routeRegexp === '^/$') {
    return routerPath === '/';
  }

  return routerPath.match(new RegExp(routeRegexp)) != null;
};
